import React from 'react'

interface Props{
    isInfoOpened: any
    currentInfoText: string
    currentInfoImg: string,
    handleOpenInfoScreen: any,
    selectedIndividual: any
}

interface State{}

class Info extends React.Component<Props,State>{
    render(): React.ReactNode {
        return(
            <div className={this.props.isInfoOpened ? 'info-main-container fade-in':'info-main-container fade-out'}>
                <div className='info-container-bullet'>
                    {
                        this.props.isInfoOpened ?
                        <React.Fragment>
                            {
                                this.props.currentInfoImg ?
                                <div className='img-info-container'>
                                    <img src={this.props.currentInfoImg}/>
                                </div>:null
                            }
                            <div className='text-info-container'>
                                {
                                    this.props.currentInfoText
                                }
                            </div>
                            <div className='info-close-btn' id='element-umbra-analytics' data-second={this.props.currentInfoText} data-value={this.props.selectedIndividual} data-type={"BULLET"} onClick = {() => {this.props.handleOpenInfoScreen(false, "", "")}}>
                                OK
                            </div>
                        </React.Fragment>:null
                    }
                </div>
            </div>
        )
    }
}

export default Info